var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"validation"},[_c('label',{staticClass:"block text-gray-700 text-smaller font-bold"},[_vm._v("\n    Kortnummer\n    "),_c('div',{ref:"card",staticClass:"border rounded py-053 pl-2",class:_vm.cardInputClasses})]),_vm._v(" "),_c('div',{staticClass:"text-error",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.cardErrors))])])
}
var staticRenderFns = []

export { render, staticRenderFns }